import React from 'react';

const Footer = () => (
    <footer className="bg-0C0313 text-white py-2 fixed bottom-0 w-full">
      <div className="container mx-auto text-center">
        <p className="text-xs">
          Copy right 2024 with ❤️. All rights reserved
        </p>
      </div>
    </footer>
  );

export default Footer;